import React, { useEffect, useState } from "react";
import { Radio } from "antd";
import { GetListId } from "../../utils/helpers";
import { API_BASE_URL, QBO_APP_BASE_URL } from "../../utils/constants";
import { DownOutlined } from "@ant-design/icons";
import axios from "axios";
import { useParams, Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { openNotification } from "../../utils/helpers";
import moment from "moment";
import { Form, Input, Button, AutoComplete, Tabs, Spin } from "antd";
import AppFooter from "../../Components/Footer";
import http from "../../api/client";

function QboAccountSettings({
  cogs,
  asset,
  expense,
  income,
  accountSettings,
  callBack,
}) {
  const params = useParams();
  const [QboField, setQboField] = useState();
  const [createItem, setCreateItem] = useState(
    accountSettings?.companySettings.item_type
  );
  const [optionsOfIncomeAccounts, setOptionsOfIncomeAccounts] = useState([]);
  const [optionsOfAssetAccounts, setOptionsOfAssetAccounts] = useState([]);
  const [optionsOfExpenseAccounts, setOptionsOfExpenseAccounts] = useState([]);
  const [optionsOfCogsAccounts, setOptionsOfCogsAccounts] = useState([]);
  const [responseText, setResponseText] = useState();
  const [savedSettings, setSavedSettings] = useState();
  const [incomeAccount, setIncomeAccount] = useState("");
  const [fieldsValue, setFieldsValue] = useState({});
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [manualSyncIsLoading, setManualSyncIsLoading] = useState(false);
  const [isManualSyncBlockVisible, setIsManualSyncBlockVisible] =
    useState(false);
  const [manualAccountsSyncIsLoading, setManualAccountsSyncIsLoading] =
    useState(false);
  const [isShowSpin, setIsShowSpin] = useState(false);
  let history = useHistory();

  useEffect(() => {
    setOptionsOfIncomeAccounts(income);
    setOptionsOfAssetAccounts(asset);
    setOptionsOfExpenseAccounts(expense);
    setOptionsOfCogsAccounts(cogs);
    setSavedSettings(accountSettings);
    if (accountSettings) {
      if (accountSettings.companySettings.item_map) {
        setQboField(accountSettings.companySettings.item_map);
      }
      if (accountSettings.companySettings.item_type) {
        setCreateItem(accountSettings.companySettings.item_type);
      }

      setFieldsValue({
        incomeAccount: "formCalculatedValue",
      });

      if (accountSettings.companySettings.sync_type === "liveSync") {
        setIsManualSyncBlockVisible(false);
      } else {
        setIsManualSyncBlockVisible(true);
      }
    }

    setIncomeAccount("abc");
  }, [cogs, asset, expense, income, accountSettings, incomeAccount]);

  const optionsQboFields = [
    { label: "Name", value: "Name" },
    { label: "SKU", value: "SKU" },
  ];

  const optionsCreateItems = [
    { label: "Non-Inventoried Items", value: "non_inventory" },
    { label: "Inventoried Items", value: "inventory_part" },
  ];

  function onChangeQboFiled(e) {
    setQboField(e.target.value);
  }

  function onChangeCreateItem(e) {
    setCreateItem(e.target.value);
  }

  function onSelectIncomeAccount(e) {}

  function onSelectExpenseAccount(e) {}

  function manualSync(e) {
    e.preventDefault();
    setManualSyncIsLoading(true);

    http
      .get("/api/qbo/manualSyncing?companyId=" + params.companyId)
      .then((res) => {
        setResponseText(res.data?.message);
        setManualSyncIsLoading(false);
        openNotification(
          "topRight",
          "Products synced successfully!",
          "Manual sync for products completed."
        );
      })
      .catch((err) => {
        console.log("err in catch of Manual Sync", err);
        setResponseText("err in catch of Manual Sync");
        setManualSyncIsLoading(false);
        if (err.response) {
          if (err.response.status === 401) {
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }
      });
  }

  function manualAccountsSync(e) {
    e.preventDefault();
    setIsShowSpin(true);
    setManualAccountsSyncIsLoading(true);
    var instance = axios.create();
    delete instance.defaults.headers.common["Authorization"];

    instance
      .post(
        QBO_APP_BASE_URL +
          "onboarding.php?companyId=" +
          params.companyId +
          "&onboardingType=accounts"
      )
      .then((res) => {
        const myArray = res.data.split("<body>");
        // console.log("myArray", JSON.parse(myArray[1]));
        if (myArray[1]) {
          openNotification(
            "topRight",
            "Accounts synced successfully!",
            JSON.parse(myArray[1]).message
          );
        }
        callBack();
        setManualAccountsSyncIsLoading(false);
        setIsShowSpin(false);
      })
      .catch((err) => {
        setResponseText("err in catch of Manual Account Sync");
        setManualAccountsSyncIsLoading(false);
      });
  }

  const [form] = Form.useForm();
  const onFinish = (values) => {
    setSaveIsLoading(true);
    values.comp_id = params.companyId;

    if (values.expenseAccount) {
      var expenseAccountListId = GetListId(
        optionsOfExpenseAccounts,
        values.expenseAccount
      );
      values.expenseAccount_ListId = expenseAccountListId;
    }
    if (values.incomeAccount) {
      var incomeAccountListId = GetListId(
        optionsOfIncomeAccounts,
        values.incomeAccount
      );
      values.incomeAccount_ListId = incomeAccountListId;
    }

    if (values.inventoriedIncomeAccount) {
      var inventoriedIncomeAccountListId = GetListId(
        optionsOfIncomeAccounts,
        values.inventoriedIncomeAccount
      );
      values.inventoriedIncomeAccount_ListId = inventoriedIncomeAccountListId;
    }
    if (values.cogsAccount) {
      var cogsAccountListId = GetListId(
        optionsOfCogsAccounts,
        values.cogsAccount
      );
      values.cogsAccount_ListId = cogsAccountListId;
    }

    if (values.inventoryAssetAccount) {
      var inventoryAssetAccountListId = GetListId(
        optionsOfAssetAccounts,
        values.inventoryAssetAccount
      );
      values.inventoryAssetAccount_ListId = inventoryAssetAccountListId;
    }

    delete values["inventoryStartDate"];
    console.log("Form Data", values);

    http
      .post("/api/qbo/saveAccountSettings", values)
      .then((res) => {
        console.log("res.data", res.data);
        setResponseText(res.data?.message);
        setSaveIsLoading(false);
        openNotification(
          "topRight",
          "Success!",
          res.data.message 
        );
      })
      .catch((err) => {
        console.log("err in catch of insert into AccountSeetings", err);
        setSaveIsLoading(false);

        if (err.response) {
          if (err.response.status === 401) {
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }
      });
  };

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 16,
      },
      sm: {
        span: 16,
      },
    },
  };

  return (
    <>
      {accountSettings && (
        <div className="flex flex-col ">
          <div className="flex-1">
            <Form
              {...formItemLayout}
              form={form}
              name="register"
              onFinish={onFinish}
              layout="vertical"
              initialValues={{
                incomeAccount:
                  accountSettings.companySettings.item_income_account,
                expenseAccount:
                  accountSettings.companySettings.item_expense_account,
                inventoriedIncomeAccount:
                  accountSettings.companySettings.item_income_inventory,
                cogsAccount:
                  accountSettings.companySettings.item_cogs_inventory,
                inventoryAssetAccount:
                  accountSettings.companySettings.item_asset_inventory,
                item_map: accountSettings.companySettings.item_map,
                item_type: accountSettings.companySettings.item_type,
              }}
              scrollToFirstError
            >
              <div className="pt-0 col-span-12 flex ">
                <div className=" col-span-10 text-lg flex justify-start ">
                  <p className="whitespace-pre font-raleway">
                    Create a <span className="font-bold ">Product</span> in{" "}
                    <span className="font-bold ">QuickBooks Online</span> when a{" "}
                    <span className="font-bold">Product </span> is created on{" "}
                    <span className="font-bold">Shopify.</span>
                  </p>
                </div>

                <div className=" col-span-12 grid grid-cols-12 border-dotted border-t-2 h-1"></div>
              </div>

              <div className=" w-full grid grid-cols-12 ">
                <div className="col-span-9   grid grid-cols-12 ">
                  {/* Matching filed */}
                  <div className="pt-2 col-span-12 grid grid-cols-12 gap-10 ">
                    <div className="col-span-12 flex justify-start">
                      <div className=" w-full   ">
                        <Form.Item
                          name="item_map"
                          label="Matching Field:"
                          tooltip={{
                            title:
                              " Select field to match shopify products with QuickBooks Online.",
                            // icon: <InfoCircleOutlined />,
                          }}
                        >
                          {/* <Radio.Group
                        options={optionsQboFields}
                        onChange={onChangeQboFiled}
                        value={QboField}
                        optionType="button"
                        buttonStyle="solid"
                      /> */}
                          <Radio.Group optionType="button" buttonStyle="solid">
                            <Radio.Button value="Name">Name</Radio.Button>
                            <Radio.Button value="SKU">SKU</Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* create item as */}
                  <div className="pt-2 col-span-12 grid grid-cols-12 gap-10">
                    <div className="col-span-12 flex justify-start">
                      <div className="w-full  ">
                        <Form.Item
                          name="item_type"
                          label=" Create items as :"
                          tooltip={{
                            title: "Tooltip with customize icon",
                            // icon: <InfoCircleOutlined />,
                          }}
                        >
                          <Radio.Group
                            optionType="button"
                            buttonStyle="solid"
                            onChange={(e) => onChangeCreateItem(e)}
                          >
                            <Radio.Button value="non_inventory">
                              Non-Inventoried Items
                            </Radio.Button>
                            <Radio.Button value="inventory_part">
                              Inventoried Items
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  {/* non-inventory case */}
                  {createItem == "non_inventory" && (
                    <>
                      {/* income Account */}
                      <div className="pt-2 col-span-12 grid grid-cols-12 w-full ">
                        <div className=" col-span-6  ">
                          <Form.Item
                            style={{ textAlign: "left" }}
                            name="incomeAccount"
                            label="Income Account:"
                            tooltip={{
                              title: "Use Income Account",
                              // icon: <InfoCircleOutlined />,
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Please select Income Account!",
                              },

                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    optionsOfIncomeAccounts.find(
                                      (o) =>
                                        o.value ===
                                        getFieldValue("incomeAccount")
                                    )
                                  ) {
                                    return Promise.resolve();
                                  }

                                  return Promise.reject(
                                    new Error("Select Valid Income Account!")
                                  );
                                },
                              }),
                            ]}
                          >
                            <AutoComplete
                              style={{
                                width: 360,
                              }}
                              options={optionsOfIncomeAccounts}
                              onChange={(value) => {
                                onSelectIncomeAccount(value);
                              }}
                              onSelect={(value) => {
                                onSelectIncomeAccount(value);
                              }}
                            >
                              <Input
                                value={"optionsOfIncomeAccounts"}
                                placeholder="Income Accounts"
                                suffix={<DownOutlined />}
                              />
                            </AutoComplete>
                          </Form.Item>
                        </div>
                        <div className="  col-span-6  ">
                          <div className="text-xs  w-full flex justify-start mt-9  h-10">
                            <div className="flex font-raleway">
                              <div>Don't see all your accounts?</div>
                              <div className="flex justify-start ml-2 items-start">
                                <div className="">
                                  try
                                  <button
                                    onClick={(e) => manualAccountsSync(e)}
                                    className="text-primary font-bold px-1"
                                  >
                                    Refresh
                                  </button>
                                </div>
                              </div>
                            </div>

                            {isShowSpin && (
                              <div className="pl-2">
                                <Spin />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* expense account */}
                      <div className="pt-2 col-span-8">
                        <Form.Item
                          style={{ textAlign: "left" }}
                          name="expenseAccount"
                          label="Expense Account:"
                          tooltip={{
                            title:
                              "Use Expense Account and it's dummy information",
                            // icon: <InfoCircleOutlined />,
                          }}
                          rules={[
                            {
                              required: true,
                              message: "Please select Expense Account!",
                            },

                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  optionsOfExpenseAccounts.find(
                                    (o) =>
                                      o.value ===
                                      getFieldValue("expenseAccount")
                                  )
                                ) {
                                  return Promise.resolve();
                                }

                                return Promise.reject(
                                  new Error("Select Valid Expense Account!")
                                );
                              },
                            }),
                          ]}
                        >
                          <AutoComplete
                            style={{
                              width: 360,
                            }}
                            options={optionsOfExpenseAccounts}
                            onSelect={(value) => {
                              onSelectExpenseAccount(value);
                            }}
                          >
                            <Input
                              placeholder="Expense Accounts"
                              suffix={<DownOutlined />}
                            />
                          </AutoComplete>
                        </Form.Item>
                      </div>
                    </>
                  )}

                  {/* Conditional ui view for Inventoried Items  */}
                  {createItem == "inventory_part" && (
                    <div className=" w-full col-span-12">
                      <div className="pt-2 col-span-7  w-full ">
                        {/* income account */}
                        <div className="col-span-12 grid grid-cols-12 w-full">
                          <div className="col-span-6 ">
                            <Form.Item
                              style={{ textAlign: "left" }}
                              name="inventoriedIncomeAccount"
                              label="Income Account"
                              tooltip={{
                                title:
                                  "Use Income Account for Inventoried Items:",
                                // icon: <InfoCircleOutlined />,
                              }}
                              rules={[
                                {
                                  required: createItem == "InventoriedItems",
                                  message: "Please select Income Account!",
                                },

                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (
                                      !value ||
                                      optionsOfIncomeAccounts.find(
                                        (o) =>
                                          o.value ===
                                          getFieldValue(
                                            "inventoriedIncomeAccount"
                                          )
                                      )
                                    ) {
                                      return Promise.resolve();
                                    }

                                    return Promise.reject(
                                      new Error("Select Valid Income Account!")
                                    );
                                  },
                                }),
                              ]}
                            >
                              <AutoComplete
                                style={{
                                  width: 360,
                                }}
                                options={optionsOfIncomeAccounts}
                                onSelect={(value) => {
                                  onSelectExpenseAccount(value);
                                }}
                              >
                                <Input
                                  placeholder="Inventoried Income Accounts"
                                  suffix={<DownOutlined />}
                                />
                              </AutoComplete>
                            </Form.Item>
                          </div>

                          <div className="col-span-6">
                            <div className="  col-span-6  ">
                              <div className="text-xs  w-full flex justify-start mt-9  h-10">
                                <div className="flex">
                                  <div>Don't see all your accounts?</div>
                                  <div className="flex justify-start ml-2 items-start">
                                    <div className="">
                                      try
                                      <button
                                        onClick={(e) => manualAccountsSync(e)}
                                        className="text-primary font-bold px-1"
                                      >
                                        Refresh
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {isShowSpin && (
                                  <div className="pl-2">
                                    <Spin />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* cogs account */}
                      <div className="pt-2 col-span-7 ">
                        <div className=" col-span-12 ">
                          <Form.Item
                            style={{ textAlign: "left" }}
                            name="cogsAccount"
                            label="COGS Account:"
                            tooltip={{
                              title: "Use COGS Account for Inventoried Items:",
                              // icon: <InfoCircleOutlined />,
                            }}
                            rules={[
                              {
                                required: createItem == "InventoriedItems",
                                message: "Please select COGS Account!",
                              },

                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    optionsOfCogsAccounts.find(
                                      (o) =>
                                        o.value === getFieldValue("cogsAccount")
                                    )
                                  ) {
                                    return Promise.resolve();
                                  }

                                  return Promise.reject(
                                    new Error("Select Valid COGS Account!")
                                  );
                                },
                              }),
                            ]}
                          >
                            <AutoComplete
                              style={{
                                width: 360,
                              }}
                              options={optionsOfCogsAccounts}
                              onSelect={(value) => {
                                onSelectExpenseAccount(value);
                              }}
                            >
                              <Input
                                placeholder="Cost Of Sales Account"
                                suffix={<DownOutlined />}
                              />
                            </AutoComplete>
                          </Form.Item>
                        </div>
                      </div>

                      {/* Asset Account */}
                      <div className="pt-2 col-span-7">
                        <div className=" col-span-12 ">
                          <Form.Item
                            style={{ textAlign: "left" }}
                            name="inventoryAssetAccount"
                            label="Asset Account:"
                            tooltip={{
                              title:
                                "Use Inventory Asset Account for Inventoried Items:",
                              // icon: <InfoCircleOutlined />,
                            }}
                            rules={[
                              {
                                required: createItem == "InventoriedItems",
                                message: "Please select Asset Account!",
                              },

                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    optionsOfAssetAccounts.find(
                                      (o) =>
                                        o.value ===
                                        getFieldValue("inventoryAssetAccount")
                                    )
                                  ) {
                                    return Promise.resolve();
                                  }

                                  return Promise.reject(
                                    new Error("Select Valid Asset Account!")
                                  );
                                },
                              }),
                            ]}
                          >
                            <AutoComplete
                              style={{
                                width: 360,
                              }}
                              options={optionsOfAssetAccounts}
                              onSelect={(value) => {
                                onSelectExpenseAccount(value);
                              }}
                            >
                              <Input
                                placeholder="Inventory Asset Account"
                                suffix={<DownOutlined />}
                              />
                            </AutoComplete>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-span-3">
                  <img src={require("../../images/icons/product_left.png")} />
                </div>
              </div>

              {isManualSyncBlockVisible === true && (
                <div className="w-full border  mt-4 py-2 px-4 grid grid-cols-12 ">
                  <div className="col-span-10 flex justify-start">
                    <div className="font-raleway text-left">
                      <h1 className=" font-bold">Manual Sync:</h1>
                      <p className="">
                        Sync orders manually (Data Sync Limit: 2 Months Old)
                      </p>
                      <div className="">
                        <p className="  whitespace-pre ">
                          Manual Sync will sync existing products starting
                          <span className="ml-1 font-bold">
                            {/* {moment(
                          accountSettings.companySettings.item_starting_date
                        ).format("MMMM do, YYYY")} */}
                            {moment(
                              accountSettings.companySettings.item_starting_date
                            )
                              .format("MM-DD-YYYY")
                              .toString()}
                          </span>
                          . You can change the date range from
                        </p>
                        <p className="whitespace-pre -mt-3 -ml-1">
                          {" "}
                          the{" "}
                          <Link to={params.companyId + "/settings"}>
                            Settings
                          </Link>{" "}
                          screen in the side menu.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-2  grid content-end mb-4">
                    <Button
                      loading={manualSyncIsLoading}
                      onClick={(e) => manualSync(e)}
                      className="h-8 ml-4 px-2 -mt-1 border-2 outline-1 hover:bg-gray-300"
                    >
                      <FontAwesomeIcon icon={faArrowsRotate} className="px-2" />
                      Manual Sync
                    </Button>
                  </div>
                </div>
              )}

              {/* Buttons save and cancel */}

              <div className=" col-span-12 grid grid-cols-12 mt-4">
                <div className="py-2 col-span-6  flex justify-start gap-4">
                  <Button
                    loading={saveIsLoading}
                    className="  w-24"
                    type="primary"
                    htmlType="submit"
                  >
                    Save
                  </Button>

                  <Button
                    loading={false}
                    className="  w-24"
                    onClick={(e) => {
                      alert("Cancel Botton Clicked!");
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          </div>

          {/* <div className="flex-none">
          <AppFooter/>
          </div> */}
        </div>
      )}
    </>
  );
}

export default QboAccountSettings;
